import script from "./PersonalfragenForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalfragenForm.vue?vue&type=script&setup=true&lang=js"

import "./PersonalfragenForm.vue?vue&type=style&index=0&id=3f802f2a&lang=css"

const __exports__ = script;

export default __exports__